import { render, staticRenderFns } from "./Index6.vue?vue&type=template&id=bf315906&scoped=true"
import script from "./Index6.vue?vue&type=script&lang=js"
export * from "./Index6.vue?vue&type=script&lang=js"
import style0 from "./Index6.vue?vue&type=style&index=0&id=bf315906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf315906",
  null
  
)

export default component.exports